import { USER_ACTIONS, REDUCERS } from '../../constants.js';

const initialUserActions = {
  reducer_type : REDUCERS.REDUCER_ACTIOS_FROM_SM,
  actionType : USER_ACTIONS.NONE,
  webLogged : false,
  ccserverLogged : false,
  language : '1',//ONLY FOR RENDER THE APP, THE CURRENT LANGUAGE IS IN THE SINGLETON
};

const userActions = (state = initialUserActions, action) => {
  state = initialUserActions;
  switch (action.type) {
    case USER_ACTIONS.NONE:
      return Object.assign({}, state, { actionType: USER_ACTIONS.NONE });
    case USER_ACTIONS.LOGIN:
      return Object.assign({}, state, { actionType: USER_ACTIONS.LOGIN, language : action.c_language, webLogged : action.webLogged, ccserverLogged : action.ccserverLogged});
    case USER_ACTIONS.CHANGE_LANGUAGE:
      return Object.assign({}, state, { actionType: USER_ACTIONS.CHANGE_LANGUAGE, language : action.c_language});
    case USER_ACTIONS.LOGOUT:
      return Object.assign({}, initialUserActions, { actionType: USER_ACTIONS.LOGOUT });
    default:
      return state;
  }
}

export default userActions;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_user_actions.js